import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DxToolbarComponent} from 'devextreme-angular';
import {dateFilters, dateFilterToPeriod} from 'shared';
import {TractorHistoryRequest} from '../tractors-history/tractors-history.component';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-tractors-history-toolbar',
  templateUrl: './tractors-history-toolbar.component.html',
  styleUrls: ['./tractors-history-toolbar.component.scss']
})
export class TractorsHistoryToolbarComponent implements OnInit {

  @ViewChild(DxToolbarComponent, {static: true})
  toolbar: DxToolbarComponent;

  @Output()
  load = new EventEmitter<TractorHistoryRequest>();

  @Output()
  export = new EventEmitter<void>();

  @Input()
  request: TractorHistoryRequest;

  @Input()
  loadingVisible = true;

  @Input()
  tractors: DataSource;

  generateButtonOptions: any;
  exportButtonOptions: any;
  dateFilters = dateFilters;
  stops: any = [
    {value: 5, label: '> 5 S'},
    {value: 15, label: '> 15 S'},
    {value: 30, label: '> 30 S'},
    {value: 60, label: '> 1 Min'},
    {value: 120, label: '> 2 Min'},
    {value: 5 * 60, label: '> 5 Min'},
    {value: 10 * 60, label: '> 10 Min'},
    {value: 20 * 60, label: '> 20 Min'},
    {value: 30 * 60, label: '> 30 Min'},
    {value: 60 * 60, label: '> 1 H'},
    {value: 120 * 60, label: '> 2 H'},
    {value: 300 * 60, label: '> 5 H'},
  ];

  constructor() {

    // Bindings
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
    this.dateChanged = this.dateChanged.bind(this);
  }

  ngOnInit(): void {

    this.generateButtonOptions = {
      icon: 'repeat',
      text: 'Génerer',
      onClick: (e: any) => {
        const result = e.validationGroup.validate();
        if (result.isValid) {
          this.load.emit(this.request);
        }
      }
    };

    this.exportButtonOptions = {
      icon: 'image',
      text: 'Exporter',
      onClick: () => {
        this.export.emit();
      }
    };
  }

  dateFilterChanged(e) {
    this.request.isToday = false;
    if (this.request.currentFilter === 0 || e.value === 0) {
      setTimeout(() => {
        this.toolbar.instance.repaint();
      }, 100);
    }
    this.request.currentFilter = e.value;
    [this.request.from, this.request.to, this.request.isToday] = dateFilterToPeriod(this.request.currentFilter);
  }

  dateChanged(e: any) {
    /*this.currentFilter = 0;
    this.request.isToday = false;*/
  }

}
